<template>
  <v-card v-if="model.id" class="elevation-2" color="grey lighten-3">
    <v-card-title class="text-h5">
      <h4 class="font-weight-bold text--primary text-uppercase">Tipo de Plazos</h4>
    </v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import { Permission } from '@/mixins/permissionMain'
export default {
  props: ['model', 'onSuccess'],
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'addDeadlinesData', code: 'config.deadlines-store' }
        ],
        titles: [
          { text: 'Plazo', value: 'plazo', class: 'black--text' },
          { text: 'Banco', value: 'banco.nombre', class: 'black--text' },
          { text: 'Seguro de Vida', value: 'seguroVida', class: 'black--text' },
          { text: 'Capital', value: 'capital', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        losading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateDeadlinesData', code: 'config.banks.deadlines-update' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-2', action: 'deleteDeadlinesData', code: 'config.banks.deadlines-delete' }
        ]
      },
      footer: {
        paging: true
      }
    },
    credits: []
  }),
  components: {
    DataTableMain
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapMutations([]),
    successAction (item) {
      item.item = this.model
      this.onSuccess(item)
    },
    tableAction (item) {
      this.onSuccess(item)
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    model (val) {
      if (val) {
        this.table.body.data = val.plazos
      }
    }
  }
}
</script>

<style>
</style>
